var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLossCompleteIcon = function SvgLossCompleteIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.8891 14.3781L20.7891 5.54492L18.0179 7.14492L23.1179 15.9781L25.8891 14.3781Z",
    fill: "#0D8426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.1634 17.2222L39.9062 10.582L37.823 8.15291L30.0802 14.7931L32.1634 17.2222Z",
    fill: "#0D8426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6016 35.575C46.0016 33.375 44.7016 31.575 43.0016 30.175C44.1016 27.075 42.8016 23.575 39.9016 21.875L33.1016 33.875C35.7016 35.375 38.8016 34.975 40.9016 33.175C42.0016 33.975 42.7016 35.175 43.1016 36.475C43.6016 38.075 43.3016 39.775 42.5016 41.275L45.7016 43.075C47.0016 40.875 47.4016 38.175 46.6016 35.575Z",
    fill: "#0D8426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.6016 29.2754L33.1016 33.9754L39.9016 21.9754L33.7016 20.2754L28.6016 29.2754Z",
    fill: "#0D8426"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0011 25.9752L23.8011 23.7752L18.9011 26.2752L17.2011 23.3752L22.1011 20.7752L20.9011 18.5752L15.9011 21.1752L14.6011 18.9752L9.20109 22.0752C6.30109 23.6752 5.10109 27.0752 6.00109 30.0752C4.80109 31.1752 3.80109 32.7752 3.30109 34.5752C2.60109 37.1752 2.90109 39.8752 4.20109 42.1752L7.40109 40.3752C6.60109 38.8752 6.40109 37.1752 6.80109 35.5752C7.00109 34.6752 7.50109 33.8752 8.10109 33.1752C10.2011 35.0752 13.4011 35.4752 16.0011 33.9752L21.4011 30.8752L20.1011 28.5752L25.0011 25.9752Z",
    fill: "#0D8426"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6004 30.275C33.5393 30.275 34.3004 29.5139 34.3004 28.575C34.3004 27.6361 33.5393 26.875 32.6004 26.875C31.6615 26.875 30.9004 27.6361 30.9004 28.575C30.9004 29.5139 31.6615 30.275 32.6004 30.275Z",
    fill: "#0D8426"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0008 25.775C35.9397 25.775 36.7008 25.0139 36.7008 24.075C36.7008 23.1361 35.9397 22.375 35.0008 22.375C34.0619 22.375 33.3008 23.1361 33.3008 24.075C33.3008 25.0139 34.0619 25.775 35.0008 25.775Z",
    fill: "#0D8426"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLossCompleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "loss-complete-icon.d3bd20538bf8f3c783b90204cd24cd5d.svg";